export default __webpack_public_path__ + "static/media/Abyssal Demon Pendant of Assault.c9331fd6.jpg";